// ThirdPartySystemId: Integer IDs for third-party systems (IPW, IPG, etc.)
// Stored in DB to save space (millions of transactions, few third-party systems)
// WARNING: Never change existing IDs, only add new ones

export const IpwSystemId = {
    DEALERTRACK: 10001,
    PCPARTPICKER: 10002,
} as const;
export const IpwSystemIdKey = {
    DEALERTRACK: 'DEALERTRACK',
    PCPARTPICKER: 'PCPARTPICKER',
} as const;
export const IpwSystemIdKeyList = ['DEALERTRACK', 'PCPARTPICKER'] as const;
export type IpwSystemIdKey = (typeof IpwSystemIdKeyList)[number];

export type IpwSystemId = (typeof IpwSystemId)[keyof typeof IpwSystemId];


// Reverse lookup: ID -> name (for display purposes)
export const IpwSystemIdToName: Record<IpwSystemId, string> = {
    [IpwSystemId.DEALERTRACK]: 'DealerTrack',
    [IpwSystemId.PCPARTPICKER]: 'PCPartPicker',
} as const;

export const IpgSystemId = {
    VALOR_US: 1,
} as const;
export const IpgSystemIdKey = {
    VALOR_US: 'VALOR_US',
} as const;
export const IpgSystemIdKeyList = ['VALOR_US'] as const;
export type IpgSystemIdKey = (typeof IpgSystemIdKeyList)[number];

export type IpgSystemId = (typeof IpgSystemId)[keyof typeof IpgSystemId];

// Reverse lookup: ID -> name (for display purposes)
export const IpgSystemIdToName: Record<IpgSystemId, string> = {
    [IpgSystemId.VALOR_US]: 'Valor US',
} as const;


export const ThirdPartySystemId = {
    CORE: 0,
    // Ipg Systems (1-9999)
    ...IpgSystemId,

    // Ipw Systems (10000-)
    ...IpwSystemId,
} as const;

export type ThirdPartySystemId = (typeof ThirdPartySystemId)[keyof typeof ThirdPartySystemId];

// Reverse lookup: ID -> name (for display purposes)
export const ThirdPartySystemIdToName: Record<ThirdPartySystemId, string> = {
    [ThirdPartySystemId.CORE]: 'CORE',
    [ThirdPartySystemId.DEALERTRACK]: 'DEALERTRACK',
    [ThirdPartySystemId.PCPARTPICKER]: 'PCPARTPICKER',
    [ThirdPartySystemId.VALOR_US]: 'VALOR_US',
} as const;
